<template>
    <div class="container-fluid mt-12">
        <div class="row">
            <div class="col-lg-12">
                <v-card-title>
                    All Agents
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details>
                    </v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="desserts" class="elevation-1">
                    <template v-slot:[`item.image`]="{ item }">
                        <v-avatar>
                            <img :src="item.image" :alt="desserts.firstname">
                        </v-avatar>
                    </template>
                    <template v-slot:[`item.action`]="{item}">
        <v-icon class="text-right" text="false" @click="viewAgent(item)">mdi-account</v-icon>
        <v-tooltip top color="default">
          <span>Agent Info</span>
        </v-tooltip>
      </template>
                </v-data-table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data: () => ({
        dialog: false,
        dialogDelete: false,
        search: '',
        headers: [
            { text: 'Image', value: 'image' },
            { text: 'Agent ID', value: 'agentId' },
            {
                text: 'First Name',
                align: 'start',
                sortable: false,
                value: 'firstname',
            },
            { text: 'Phone Number', value: 'phoneNO' },
            {
                text: 'Action',
                value: 'action'
            }
        ],
        desserts: [],
    }),

    async mounted() {
        // const retrievedData = localStorage.getItem('token');
        // console.log(JSON.parse(retrievedData));
        // const token = JSON.parse(retrievedData);
const url = process.env.VUE_APP_UB_V1_API_ENDPOINT+'agent'
        await axios.all([
            axios.get(url),
            // axios.get('http://localhost:3000/api/v1/jwtauth/user/users', {
            //     headers: {
            //         'token': `Bearer ${token}`
            //     }
            // }),
            // axios.get('http://localhost:3000/api/v1/jwtauth/riders/rider', {
            //     headers: {
            //         'token': `Bearer ${token}`
            //     }
            // }),
        ])
            .then(axios.spread((response1) => {
                this.request = response1.data.data.nbHits
                console.log(response1.data.data);
                response1.data.data.allAgents.forEach(elem => {
                    this.desserts.push({
                        image: elem.passport,
                        firstname: elem.firstName,
                        agentId: elem.agentId,
                        phoneNO: elem.agentsNumber,
                        agent: elem
                    })
                });
                //response2 is the result of second call
            }))
            .catch(function (error) {
                console.log(error);
            });
        // console.log(this.desserts[0].image);

    },

    methods: {
        viewAgent(item){
            console.log(item);
            const encoded = btoa(JSON.stringify(item.agent))
            this.$router.push(`/agent-details/${encoded}`)
        },
        uploadFile() {
            this.editedItem.image = this.$refs.img.files[0];
            console.log(this.editedItem.image);
        },

        editItem(item) {
            this.editedIndex = this.desserts.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },

        deleteItem(item) {
            this.editedIndex = this.desserts.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },

        deleteItemConfirm() {
            this.desserts.splice(this.editedIndex, 1)
            this.closeDelete()
        },

        close() {
            this.dialog = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        closeDelete() {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        async save() {
            const retrievedData = localStorage.getItem('token');
            console.log(JSON.parse(retrievedData));
            const token = JSON.parse(retrievedData);
            const riderId = this.editedItem.riderId
            console.log(this.editedItem.image);


            let formData = new FormData();
            formData.append('photo', this.editedItem.image)

            if (this.editedIndex > -1) {
                await axios.patch(`http://localhost:3000/api/v1/jwtauth/riders/rider/${riderId}`,
                    {
                        firstName: this.editedItem.firstname,
                        lastName: this.editedItem.lastname,
                        driversLiscence: this.editedItem.liscence,
                        email: this.editedItem.email,
                        phoneNumber: this.editedItem.phoneNO,
                    },
                    {
                        headers: {
                            'token': `Bearer ${token}`
                        }
                    })
                    .then((response) => {
                        console.log(response);
                        Object.assign(this.desserts[this.editedIndex], this.editedItem)
                        this.close()
                    })
                    .catch((error) => {
                        console.log(error);
                    })

            } else {
                await axios.post(`http://localhost:3000/api/v1/jwtauth/riders/rider`,
                    {
                        firstName: this.editedItem.firstname,
                        lastName: this.editedItem.lastname,
                        driversLiscence: this.editedItem.liscence,
                        email: this.editedItem.email,
                        phoneNumber: this.editedItem.phoneNO,
                    },
                    {
                        headers: {
                            'token': `Bearer ${token}`
                        }
                    })
                    .then((response) => {
                        const item = response.data.data.rider;
                        console.log(response.data.data.rider);
                        this.editedItem = {
                            liscence: item.driversLiscence,
                            createdAt: item.createdAt.split("T")[0],
                            createdBy: item.createdBy.name,
                            image: item.photo,
                            riderId: item._id,
                            firstname: item.firstName,
                            lastname: item.lastName,
                            email: item.email,
                            phoneNO: item.phoneNumber,
                            status: item.verified,
                        };
                        this.desserts.push(this.editedItem)
                        this.close()
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            }

            // if (this.editedIndex > -1) {
            //     Object.assign(this.desserts[this.editedIndex], this.editedItem)
            // } else {
            //     this.desserts.push(this.editedItem)
            // }
            // this.close()
        },
    },
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');
@import url('https://fonts.googleapis.com/css?family=Caveat');

.container-fluid {
    // position: absolute;
    // top: 10%;
    padding: 5rem;
}

.newR {
    width: auto;
    height: auto;
    padding: 0.5rem;
    background: #21618C;
    // border-radius: 3px;
    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    text-align: center;

    color: #FFFFFF;
}

.newR2 {
    width: auto;
    height: auto;
    padding: 0.5rem 3rem;
    margin-left: 2rem;
    background: #21618C;
    // border-radius: 3px;
    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    text-align: center;

    color: #FFFFFF;
}

.cancl {
    width: auto;
    height: auto;
    padding: 0.5rem 3rem;
    margin-left: 2rem;
    background: grey;
    // border-radius: 3px;
    font-family: 'Proxima Nova';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    color: #fff;
}

.inputD {
    width: 100%;
    height: 46px;
    padding: 0 1rem;
    background: #FFFFFF;
    border: 0.5px solid #B0AFAF;
    border-radius: 4px;

    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height */


    color: #21618C;
}
</style>